import classNames from 'classnames';
import React from 'react'
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string
};

const defaultProps = {

};

const CardAction = (
    {
        className,
        ...props
    }) => {

    const prefix = 'card-action';

    const classes = classNames(
        prefix,
        className
    );

    const Component = 'div';

    return (
        <Component
            className={classes}
            {...props} />
    );
}

CardAction.displayName = 'CardAction';
CardAction.propTypes = propTypes;
CardAction.defaultProps = defaultProps;

export default CardAction;